import type { Locale } from "@shelflist/shared";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LANGUAGE, getBrowserOverride, resolveLanguage } from "./languages";
import { DEFAULT_NAMESPACE, NAMESPACES, resources } from "./resources";

export function initI18n() {
  const language = resolveLanguage({ browserOverride: getBrowserOverride() });
  void i18n.use(initReactI18next).init({
    resources,
    lng: language,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: ["en", "de"],
    ns: NAMESPACES,
    defaultNS: DEFAULT_NAMESPACE,
    interpolation: { escapeValue: false },
    returnNull: false,
    saveMissing: true,
    missingKeyHandler: (languages, namespace, key) => {
      console.warn(`[i18n] missing key ${namespace}:${key} for ${languages.join(",")}`);
    },
  });
  syncDocumentLanguage(language);
  i18n.on("languageChanged", syncDocumentLanguage);
  return i18n;
}

function syncDocumentLanguage(language: string) {
  document.documentElement.lang = language;
}

/** Applies the language for the given user (or the browser rules when signed out). */
export function applyLanguage(userLocale: Locale | null | undefined) {
  const language = resolveLanguage({ userLocale, browserOverride: getBrowserOverride() });
  if (i18n.language !== language) void i18n.changeLanguage(language);
}

export { i18n };
